"use client";

import * as React from "react";
import styled from "styled-components";
import Badge from "../Badge";
import defaultTheme from "../defaultTheme";
const StyledNotificationBadge = styled.div.withConfig({
  displayName: "NotificationBadge__StyledNotificationBadge",
  componentId: "sc-15j4hj9-0"
})([".orbit-badge-primitive{width:", ";padding:0;}"], ({
  theme
}) => theme.orbit.widthBadgeCircled);
StyledNotificationBadge.defaultProps = {
  theme: defaultTheme
};
const NotificationBadge = ({
  type,
  children,
  icon,
  ariaLabel,
  dataTest,
  id
}) => {
  return /*#__PURE__*/React.createElement(StyledNotificationBadge, null, /*#__PURE__*/React.createElement(Badge, {
    type: type,
    dataTest: dataTest,
    id: id,
    icon: icon,
    ariaLabel: ariaLabel
  }, !icon && children));
};
export default NotificationBadge;